import { useState } from 'react';
import { FRESH_FOCUS, focusStep } from '../../utils/spores/focus';
import { sampleVideo, useFrameSampler } from './useFrameSampler';

/*
 * The focus meter of a live camera, shared by every camera shown in the app
 * (CameraControls.js): each sample of the frame pipeline (useFrameSampler.js;
 * tests inject `sampler`) steps the meter (utils/spores/focus.js): the
 * reading against the best this view has had, and Sharp / Nearly / Blurry.
 */
export { SAMPLE_MS, SAMPLE_WIDTH, sampleVideo } from './useFrameSampler';

/**
 * The focus meter of the live video in `videoRef` while `live`. [meter, reset].
 * `onSample` also gets each sample, so whatever else reads the camera shares this one pipeline; `spores` asks it for the live count.
 */
export function useFocusMeter(videoRef, live, sampler = sampleVideo, { onSample = null, spores = false } = {}) {
  const [meter, setMeter] = useState(FRESH_FOCUS);
  useFrameSampler(videoRef, live, (sample) => {
    setMeter(m => focusStep(m, sample.sharpness));
    if (onSample) onSample(sample);
  }, { sampler, spores });
  return [meter, () => setMeter(FRESH_FOCUS)];
}
